import { useMutation } from 'react-query';
import { postInvestorLogo } from '../apis/PostInvestorLogo';

export const usePostInvestorLogoMutation = () => useMutation(postInvestorLogo);
